import { combineReducers, Reducer } from "redux";
import dataReducer from "./reducers/data";
import uiReducer from "./reducers/ui";
import { IStateApp } from "./StoreInterface";

export const rootReducer: Reducer<IStateApp> = combineReducers({
  data: dataReducer,
  ui: uiReducer
});



// WEBPACK FOOTER //
// ./src/store/index.tsx